export default "__VITE_ASSET__DovlYJY$__"